import { computed, defineComponent, onMounted, ref } from "vue";


import { GET_TOP_NAVIGATION } from "@/services/top-navigation-service";
import { TopNavigationModel } from "@/models/topNavigation";
import { currentSiteId, originalUrl } from "@/extensions/extra";
import { returnErrors } from "@/utils/returnErrors";

import { notifyError } from "@/utils/notifier.js";

export default defineComponent({
  name: "TopNavigationSettings",
  props: {
    items: {
      type: String,
      required: true,
      default: "mediakiwi",
    },
  },
  components: {},

  setup(props) {
    const topNavigationModel = new TopNavigationModel();
    const originalUrlValue = computed(() => `${props.items}`);
    const temp = ref([]);
    const groupType = ref("PROFILE");

    onMounted(() => {
      getTopNavigation();
    });

    async function getTopNavigation() {
      topNavigationModel.currentSiteId = currentSiteId;
      topNavigationModel.originalUrl = originalUrl;
      const [error, response] = await GET_TOP_NAVIGATION(
        topNavigationModel,
        groupType.value,
      );
      if (error) {
        const errorMessage: any = returnErrors(error);
        notifyError(false, errorMessage, "negative", "report_problem");
      } else {
        temp.value = response.items[0].items;
      }
    }

    return {
      topNavigationModel,
      getTopNavigation,
      originalUrlValue,
      groupType,
      list: temp,
    };
  },
});
